import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { PaymentOrder } from '../../../types';
import Input from '../Input';
import Select from '../Select';

interface ProviderPaymentSectionProps {
  register: UseFormRegister<PaymentOrder>;
  errors: FieldErrors<PaymentOrder>;
  providerOptions: { value: string; label: string }[];
  bankOptions: { value: string; label: string }[];
  currencyOptions: { value: string; label: string }[];
  paymentMethodOptions: { value: string; label: string }[];
  paymentMethod: string;
  selectedCurrency: string;
}

const ProviderPaymentSection: React.FC<ProviderPaymentSectionProps> = ({
  register,
  errors,
  providerOptions,
  bankOptions,
  currencyOptions,
  paymentMethodOptions,
  paymentMethod,
  selectedCurrency,
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-lg font-semibold text-gray-900">Provider & Payment Details</h2>
      </div>
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Select
              label="Provider"
              {...register('providerId', { required: 'Provider is required' })}
              options={providerOptions}
              error={errors.providerId?.message}
            />
          </div>
          <div>
            <Select
              label="Payment Method"
              {...register('paymentMethod', { required: 'Payment method is required' })}
              options={paymentMethodOptions}
              error={errors.paymentMethod?.message}
            />
          </div>
          {paymentMethod === 'bank_transfer' && (
            <div>
              <Select
                label="Bank Account"
                {...register('bankId', { required: 'Bank account is required for bank transfers' })}
                options={bankOptions}
                error={errors.bankId?.message}
              />
            </div>
          )}
          {paymentMethod === 'check' && (
            <div>
              <Input
                label="Check Number"
                {...register('checkNumber', { required: 'Check number is required for check payments' })}
                error={errors.checkNumber?.message}
              />
            </div>
          )}
          <div>
            <Select
              label="Currency"
              {...register('currency', { required: 'Currency is required' })}
              options={currencyOptions}
              error={errors.currency?.message}
            />
          </div>
          {selectedCurrency === 'USD' && (
            <div>
              <Input
                label="Exchange Rate (EGP per USD)"
                type="number"
                step="0.01"
                {...register('exchangeRate', { 
                  required: 'Exchange rate is required for USD currency',
                  min: { value: 0.01, message: 'Exchange rate must be greater than 0' }
                })}
                error={errors.exchangeRate?.message}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProviderPaymentSection;
